import { useMemo } from 'react';

import { AgentPresenceEventStatus } from '@repo/sdk/models/components';

import { useCurrentAgentStatus } from './use-current-agent-status';

export type AgentStatusVariant = 'offline' | 'unentitled';

interface AgentStatusDisplayResult {
  status: AgentPresenceEventStatus;
  bannerVariant: AgentStatusVariant | null;
  splashVariant: AgentStatusVariant | null;
  isActionRestricted: boolean;
}

export const useAgentStatusDisplay = (): AgentStatusDisplayResult => {
  const { status } = useCurrentAgentStatus();

  return useMemo(() => {
    let variant: AgentStatusVariant | null = null;

    if (status === AgentPresenceEventStatus.Unentitled) {
      variant = 'unentitled';
    } else if (status === AgentPresenceEventStatus.Offline) {
      variant = 'offline';
    }

    return {
      status,
      bannerVariant: variant,
      splashVariant: variant,
      isActionRestricted: variant !== null,
    };
  }, [status]);
};
